import { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

import AngleDownSvg from './angle-down.svg?react';
import AngleLeftSvg from './angle-left.svg?react';
import AngleRightSvg from './angle-right.svg?react';
import AngleUpSvg from './angle-up.svg?react';
import ArrowDownSvg from './arrow-down.svg?react';
import ArrowLeftSvg from './arrow-left.svg?react';
import ArrowUpSvg from './arrow-up.svg?react';
import BuildingSvg from './building.svg?react';
import CalendarOutlinedSvg from './calendar-outlined.svg?react';
import CameraSvg from './camera.svg?react';
import CaretDownSvg from './caret-down.svg?react';
import CarsSvg from './cars.svg?react';
import CircleErrorOutlinedSvg from './circle-error-outlined.svg?react';
import CircleErrorSolidSvg from './circle-error-solid.svg?react';
import CircleInfoSolidSvg from './circle-info-solid.svg?react';
import CircleInfoSvg from './circle-info.svg?react';
import CircleQuestionSvg from './circle-question.svg?react';
import CircleSuccessOutlinedSvg from './circle-success-outlined.svg?react';
import CircleSuccessSolidSvg from './circle-success-solid.svg?react';
import ClipSvg from './clip.svg?react';
import ClockOutlinedSvg from './clock-outlined.svg?react';
import CloseSvg from './close.svg?react';
import CommentSvg from './comment.svg?react';
import DownloadSvg from './download.svg?react';
import EditSvg from './edit.svg?react';
import EyeSvg from './eye.svg?react';
import FileExcelOutlinedSvg from './file-excel-outlined.svg?react';
import FileJpgOutlinedSvg from './file-jpg-outlined.svg?react';
import FileOutlinedSvg from './file-outlined.svg?react';
import FilePdfOutlinedSvg from './file-pdf-outlined.svg?react';
import FilePngOutlinedSvg from './file-png-outlined.svg?react';
import FileXlsOutlinedSvg from './file-xls-outlined.svg?react';
import FileSvg from './file.svg?react';
import FolderFilledSvg from './folder-filled.svg?react';
import FolderOpenSvg from './folder-open.svg?react';
import GearOutlineSvg from './gear-outlined.svg?react';
import GearSvg from './gear.svg?react';
import LinkSvg from './link.svg?react';
import ListChecksSvg from './list-checks.svg?react';
import ListSvg from './list.svg?react';
import MailOutlinedSvg from './mail-outlined.svg?react';
import PasteSvg from './paste.svg?react';
import PhoneSvg from './phone.svg?react';
import PlusSvg from './plus.svg?react';
import PowerOffSvg from './power-off.svg?react';
import ResendArrowSvg from './resend-arrow.svg?react';
import RotateSvg from './rotate.svg?react';
import SearchSvg from './search.svg?react';
import TableLayoutSvg from './table-layout.svg?react';
import TableQuestionSvg from './table-question.svg?react';
import TrashSvg from './trash.svg?react';
import TruckSvg from './truck.svg?react';
import UploadSvg from './upload.svg?react';
// import UserShieldSvg from './user-shield.svg?react';
import UserSvg from './user.svg?react';
import UsersSvg from './users.svg?react';
import WarningSvg from './warning.svg?react';
import WhatsappSvg from './whatsapp.svg?react';

const withProps = (Icon: React.ComponentType<IconProps>) => {
  const IconComponent = ({ className = '', ...props }: IconProps) => {
    return <Icon className={className} {...props} />;
  };

  return IconComponent;
};

export const CircleQuestion = withProps(CircleQuestionSvg);
export const CircleErrorOutlined = withProps(CircleErrorOutlinedSvg);
export const CircleErrorSolid = withProps(CircleErrorSolidSvg);
export const CircleSuccessOutlined = withProps(CircleSuccessOutlinedSvg);
export const CircleSuccessSolid = withProps(CircleSuccessSolidSvg);
export const ArrowDown = withProps(ArrowDownSvg);
export const Trash = withProps(TrashSvg);
export const Warning = withProps(WarningSvg);
export const TableLayout = withProps(TableLayoutSvg);
export const User = withProps(UserSvg);
export const Building = withProps(BuildingSvg);
export const Users = withProps(UsersSvg);
export const Cars = withProps(CarsSvg);
export const ListChecks = withProps(ListChecksSvg);
export const AngleDown = withProps(AngleDownSvg);
export const AngleLeft = withProps(AngleLeftSvg);
export const AngleRight = withProps(AngleRightSvg);
export const Close = withProps(CloseSvg);
export const Eye = withProps(EyeSvg);
export const Upload = withProps(UploadSvg);
export const ArrowLeft = withProps(ArrowLeftSvg);
export const Camera = withProps(CameraSvg);
export const Gear = withProps(GearSvg);
export const PowerOff = withProps(PowerOffSvg);
export const CaretDown = withProps(CaretDownSvg);
export const FileExcelOutlined = withProps(FileExcelOutlinedSvg);
export const CircleInfo = withProps(CircleInfoSvg);
export const CircleInfoSolid = withProps(CircleInfoSolidSvg);
export const ArrowUp = withProps(ArrowUpSvg);
export const Search = withProps(SearchSvg);
export const Plus = withProps(PlusSvg);
export const ResendArrow = withProps(ResendArrowSvg);
export const Edit = withProps(EditSvg);
export const Paste = withProps(PasteSvg);
export const GearOutlined = withProps(GearOutlineSvg);
export const Clip = withProps(ClipSvg);
export const FileOutlined = withProps(FileOutlinedSvg);
export const FileJpgOutlined = withProps(FileJpgOutlinedSvg);
export const FilePdfOutlined = withProps(FilePdfOutlinedSvg);
export const FilePngOutlined = withProps(FilePngOutlinedSvg);
export const FileXlsOutlined = withProps(FileXlsOutlinedSvg);
export const Download = withProps(DownloadSvg);
export const List = withProps(ListSvg);
export const Truck = withProps(TruckSvg);
export const AngleUp = withProps(AngleUpSvg);
export const CalendarOutlined = withProps(CalendarOutlinedSvg);
export const File = withProps(FileSvg);
export const FolderFilled = withProps(FolderFilledSvg);
export const FolderOpen = withProps(FolderOpenSvg);
export const TableQuestion = withProps(TableQuestionSvg);
// export const UserShield = withProps(UserShieldSvg);
export const ClockOutlined = withProps(ClockOutlinedSvg);
export const Rotate = withProps(RotateSvg);
export const Comment = withProps(CommentSvg);
export const Phone = withProps(PhoneSvg);
export const Whatsapp = withProps(WhatsappSvg);
export const MailOutlined = withProps(MailOutlinedSvg);
export const Link = withProps(LinkSvg);
